// extracted by mini-css-extract-plugin
export default {"container":"styles_container__125ml","description":"styles_description__+6vgn"};